import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as history from "app/main/history";
import { getColumnas } from "./columns";
import { observeResource } from "kea-resource";
import { resources, componentToRx } from "app/main/std";
import { createSelector } from "reselect";
import { PaquetePPFiltroView } from "./filtro";
import { KeaResourceFriendlyError } from "kea-resource/dist/http/keamiddleware";
import { openPdf } from "kea-react";
import { createSelectorRx } from "keautils";

type Entity = models.PaquetePPDto;

interface State {
    filtro: models.PaquetePPFiltro;
}
interface Props {
    permisos: models.Rol;
    session: models.Session;
}

class ListaPaquetesPPNoRX extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            filtro: {} as any
        };
    }

    permisos = (props: Props) => props.permisos;
    session = (props: Props) => props.session;
    idClienteUsuario = createSelectorRx(this.permisos, this.session, (permisos, session) => permisos.Documentacion.DocumentarCualquierClienteOrigen ? undefined : (session.IdCliente || undefined));

    onRegresar = () => history.go("../");
    onAgregar = () => history.go("./new");
    onVer = (x: Entity) => history.go("./" + x.IdRegistro);
    MostrarBotonPagarPAquete = (x: Entity) => !this.props.permisos.PaquetesPP.MarcarPaquetesPagados 
    || x.TipoPagoFactura == models.TipoPagoFactura.Credito 
    || ( x.FacturaContadoPagada && x.TipoPagoFactura == models.TipoPagoFactura.Contado  )
    filtro = (x: State) => x.filtro;
    items = createSelector(this.filtro, filtro => observeResource(resources.PaquetePP.Query, filtro));


    onAgregarValidarpermisos = () => 
    {
        if (this.props.permisos.PaquetesPP.Agregar) {
            history.go("./new");    
        }
        else
        {
            kea.message("Usuario sin permisos", "Su usuario no tiene permisos para realizar la accion", "warning"); 
        }
    }
    onFacturar = async (x: Entity) => {
        if (x.EstaFacturado) {
            await kea.message("El paquete ya esta facturado");
            return;
        }

        if (await kea.yesno("¿Crear la factura sin timbrar?")) {
            await resources.PaquetePP.FacturarPaquetePP(x.IdRegistro);
            await kea.message("Paquete facturado", "Se creó la factura sin timbrar");
        }
    }

    onFacturarTimbrar = async (x: Entity) => {
        if (x.EstaFacturado) {
            await kea.message("El paquete ya esta facturado");
            return;
        }

        if (await kea.yesno("¿Facturar y timbrar el paquete de PP")) {
            await resources.PaquetePP.FacturarTimbrarPaquetePP(x.IdRegistro);
            await kea.message("Paquete facturado", "Se creó la factura sin timbrar");
        }
    }

    onImprimir = async (x: Entity) => {
        const pdf = await resources.PaquetePP.ImprimirGuias(x.IdRegistro, "");
        openPdf(pdf, "Paquete de PP");
    }

    onCancelarGuias = async (x:Entity) => {
        if(await kea.yesno("¿Cancelar todas las guías de este paquete?")) {
            const folios= await resources.PaquetePP.CancelarGuias(x.IdRegistro);

            if(folios.length == 0) {
                await kea.message("No hay guías que cancelar en el paquete");
                return;
            }

            const folioStr = folios.join(", ");
            await kea.message("Se cancelaron las guias: " + folioStr);
        }
    }

    onCancelarPaquetePP = async (x:Entity) => {
        if(await kea.yesno("¿Cancelar paquete?")) {
            const res= await resources.PaquetePP.CancelarPaquetePP(x.IdRegistro);
            if(res) {
                await kea.message("Paquete Cancelado ");

                await resources.Factura.CancelarFacturaPaquetePP( res , x.IdRegistro )
                window.location.reload()
                return;
            }
        }
    }

    PagarPaquetePP = async (x:Entity) => {
        if(await kea.yesno("¿Marcar Paquete pp Pagado?")) {
            if(x.FacturaContadoPagada)
            {
                await kea.message("La factura de este paquete ya esta marcada como pagada");
            }
            else
            {
                const res= await resources.PaquetePP.PagarPaquetePP(x.IdRegistro);

                if(res) {
                    await kea.message("Paquete pagado correctamente");
                    window.location.reload()
                }
                else
                {
                    await kea.message("Error al intenar pagar el paquete");
                }
            }
            return;
        }
    }

    render() {
        const cols = getColumnas(this);
        const items = this.items(this.state);
        const idClienteUsuario = this.idClienteUsuario(this.props);

        return (
            <div>
                <kea.Title titulo="Paquetes de guías prepagadas" onRegresar={this.onRegresar} onAgregar={ this.onAgregarValidarpermisos } />
                <PaquetePPFiltroView value={this.state.filtro} onChange={x => this.setState({ filtro: x })} idClienteOrigen={idClienteUsuario} />
                <kea.Grid2 columnas={cols} cookieKey={"ListaPaquetesPPListCookieKey"} items={items} />
            </div>
        )
    }
}

const ListaPaquetesPPRX = componentToRx(ListaPaquetesPPNoRX);

const permisos = resources.User.PermisoRx;
const session = resources.User.SessionRx;
export class ListaPaquetesPP extends React.PureComponent<Props, State> {
    render() {
        return <ListaPaquetesPPRX
            permisos={permisos}
            session={session}
        />
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/paquetespp/list/index.tsx